import React, { useCallback, useEffect, useState } from 'react';
import { PurchaseToast } from './PurchaseToast';
import { scanPageForProducts, getRandomProduct } from '../utils/productScanner';
import { getRandomName, getRandomCity } from '../utils/purchaseData';
interface NotificationData {
  name: string;
  city: string;
  productTitle: string;
  editionLabel: string;
  priceText: string;
  thumbnailUrl: string;
}
export function PurchaseNotifications() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentNotification, setCurrentNotification] = useState<NotificationData | null>(null);
  const [products, setProducts] = useState<ReturnType<typeof scanPageForProducts>>([]);
  // Scan for products on mount
  useEffect(() => {
    // Wait for DOM to be fully rendered
    const timer = setTimeout(() => {
      const scannedProducts = scanPageForProducts();
      setProducts(scannedProducts);
    }, 500);
    return () => clearTimeout(timer);
  }, []);
  const showNotification = useCallback(() => {
    if (products.length === 0) return;
    const product = getRandomProduct(products);
    const name = getRandomName();
    const city = getRandomCity();
    setCurrentNotification({
      name,
      city,
      productTitle: product.title,
      editionLabel: product.editionLabel,
      priceText: product.priceText,
      thumbnailUrl: product.thumbnailUrl
    });
    setIsVisible(true);
    // Hide after 4 seconds
    setTimeout(() => {
      setIsVisible(false);
    }, 4000);
  }, [products]);
  useEffect(() => {
    if (products.length === 0) return;
    // First notification after 3 seconds
    const initialTimer = setTimeout(() => {
      showNotification();
    }, 3000);
    // Subsequent notifications at random intervals (8-15 seconds)
    const scheduleNext = () => {
      const delay = 8000 + Math.random() * 7000; // 8-15 seconds
      return setTimeout(() => {
        showNotification();
        scheduleNext(); // Schedule the next one
      }, delay);
    };
    // Start scheduling after the first notification completes (3s + 4s display + 1s buffer)
    const recurringTimer = setTimeout(() => {
      scheduleNext();
    }, 8000);
    return () => {
      clearTimeout(initialTimer);
      clearTimeout(recurringTimer);
    };
  }, [products, showNotification]);
  if (!currentNotification) return null;
  return <PurchaseToast isVisible={isVisible} name={currentNotification.name} city={currentNotification.city} productTitle={currentNotification.productTitle} editionLabel={currentNotification.editionLabel} priceText={currentNotification.priceText} thumbnailUrl={currentNotification.thumbnailUrl} data-id="element-328" />;
}